import { Component, Input, OnInit } from '@angular/core';
import { UtilService, VariablesService } from '../../shared/services';

@Component({
  selector: 'app-thankyou-success-head',
  templateUrl: './thankyou-success-head.component.html',
  styleUrls: ['./thankyou-success-head.component.scss']
})
export class ThankyouSuccessHeadComponent implements OnInit {

  @Input() config;
  isMobile;
  userData;
  pan_updated = false;

  constructor(
    public utilService: UtilService,
    public vars: VariablesService
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService?.isMobile();
    this.vars.userData.subscribe(user => {
      this.userData = user;
    });
  }

  panUpdateToggle = (e) => {
    this.pan_updated = e;
  }

}
